import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  setAddress,
  setShowAddressForm,
} from "../../../../store/actions/newOrderSlice";
import AddressForm from "./AddressForm";
import { dispatchSnackBarMessage } from "../../../../utils/snackbar";

/**
 * AddressFormModal - Modal dialog for adding/editing delivery address
 *
 * Opens when: showAddressForm is true
 * Closes when: User clicks close or completes form
 */
const AddressFormModal = () => {
  const dispatch = useDispatch();
  const showAddressForm = useSelector(
    (state) => state.newOrder.showAddressForm
  );
  const address = useSelector((state) => state.newOrder.address);

  const handleClose = () => {
    dispatch(setShowAddressForm(false));
  };

  // Function to validate address completeness
  const isAddressValid = (addr) => {
    if (!addr) return false;

    // Check for required fields
    const hasRequiredFields =
      addr.street && addr.cep && addr.neighborhood && addr.house_number;

    // Additional check for latitude and longitude
    const hasCoordinates =
      addr.lat !== undefined &&
      addr.lat !== null &&
      addr.lat !== "" &&
      addr.long !== undefined &&
      addr.long !== null &&
      addr.long !== "";

    return hasRequiredFields && hasCoordinates;
  };

  const handleSetAddress = (newAddress) => {
    if (isAddressValid(newAddress)) {
      dispatch(setAddress(newAddress));
      dispatch(setShowAddressForm(false)); // Close modal after saving
      dispatchSnackBarMessage(
        Date.now(),
        "Endereço salvo com sucesso!",
        "success"
      );
    } else {
      dispatchSnackBarMessage(
        Date.now(),
        "Endereço incompleto. Verifique se todos os campos obrigatórios estão preenchidos e se as coordenadas foram calculadas.",
        "error"
      );
    }
  };

  return (
    <Dialog
      open={showAddressForm}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationOnIcon color="primary" />
            <Typography variant="h6" fontWeight={600}>
              Endereço de Entrega
            </Typography>
          </Box>
          <IconButton
            onClick={handleClose}
            size="small"
            aria-label="Fechar"
            sx={{
              "&:hover": {
                bgcolor: "action.hover",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <AddressForm address={address} setAddress={handleSetAddress} />
      </DialogContent>
    </Dialog>
  );
};

export default AddressFormModal;
